module.exports = __webpack_public_path__ + "static/media/icon-login-faslogo@2x.225f0da3.png";